module.exports = __webpack_public_path__ + "assets/img/Interiors-Australia-Landing-Page-w720.ee7345c1.jpg";